import CrudModel from './CrudModel';

export default class CampaignListsModel extends CrudModel {
    constructor(entity) {
        super(entity);
    }

    static toCrud({ data }) {
        return data;
    }

    static toList({ data }) {
        return data;
    }

    static toDetail(data) {
        const description = String(data?.description ?? data?.descripcion ?? '').trim();

        return {
            ...data,
            description,
            name: description,
        };
    }
}
